<template>
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">
                <i class="fas fa-plus mr-2"></i>
                Add Photos to Gallery
            </h1>
        </div>

        <!-- Add Photos Form -->
        <PhotoGalleryForm 
            :is-edit-mode="false"
            @upload-success="onUploadSuccess"
            @upload-error="onUploadError"
            @cancel="onFormCancel"
        />

        <!-- Toast Messages -->
        <Toast />
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import PhotoGalleryForm from '../../components/photo-gallery/PhotoGalleryForm.vue'
import Toast from 'primevue/toast'

export default defineComponent({
    name: "PhotoGalleryAddPage",
    components: {
        PhotoGalleryForm,
        Toast
    },
    methods: {
        onUploadSuccess(data) {
            console.log('Upload successful:', data)
            
            // Show success toast
            this.$toast.add({
                severity: 'success',
                summary: 'Upload Successful',
                detail: data.message,
                life: 5000
            })
            
            // Redirect back to gallery after successful upload
            setTimeout(() => {
                this.$router.push('/photo-gallery')
            }, 2000) // Wait 2 seconds to show the success message
        },
        
        onUploadError(error) {
            console.error('Upload error:', error)
            
            // Show error toast
            this.$toast.add({
                severity: 'error',
                summary: 'Upload Failed',
                detail: error.message || 'An error occurred during upload',
                life: 5000
            })
        },
        
        onFormCancel() {
            console.log('Form cancelled')
            this.$router.push('/photo-gallery')
        }
    }
})
</script>

<style scoped>
.container-fluid {
    padding: 1.5rem;
}

@media (max-width: 576px) {
    .d-sm-flex {
        flex-direction: column;
        align-items: stretch !important;
        gap: 1rem;
    }
}
</style>
